<template lang="pug">
  v-layout.contact-profile-wrapper.column(v-rc-loader="ambassadorValuesLoading")
    v-layout.column
      v-layout.column
        v-layout.justify-end.align-center.px-3.pb-2
          .subheading Associer {{ type.objectType }}
          v-dialog(width="35%" v-model="addSheetOpen" persistent)
            v-btn(slot="activator" fab color="primary" small @click="getAvailableSheets")
              v-icon(medium) add
            v-card
              v-card-title.white--text.title.primary.elevation-4
                v-layout.justify-center.align-center
                  v-flex.xs10.offset-xs1.text-xs-center(v-if="type.objectType") ASSOCIER {{ type.objectType.toUpperCase() }}
                  v-flex.xs1.text-xs-right
                    v-icon(large dark @click="addSheetOpen = false") close
              v-card-text.managed-brands(v-rc-loader="availableSheetsLoading")
                v-layout.managed-brand.click(v-for="(sheet, index) in availableSheets" :class="index === 0 ? 'first-brand' : ''" :key="sheet.id" @click="affectSheet(sheet.id)")
                  v-flex.xs6
                    v-layout.fill-height.column.justify-center.pl-4
                      .title.pb-2 {{ sheet.raison_sociale }}
                      .body-1 {{ categories[sheet.bordereau.toLowerCase()].toUpperCase() }},
                      .subheading {{ sheet.commune }}, {{ sheet.code_postal }}
                  v-flex.xs6
                    v-layout.justify-center.px-5
                      v-img(v-if="sheet.medias[0]" :src="sheet.medias[0].url" height="150px")
                      .no-image(v-else)
                  //- v-flex.xs6.px-2
                    v-card.mb-3.available-sheet
                      v-card-text.sheet-thumb.pa-0
                      v-card-title.justify-center.text-xs-center
          v-dialog(v-model="sheetCustomFieldsOpen" width="50%" persistent)
            v-card
              v-card-title.white--text.title.primary.elevation-4
                v-layout.justify-center.align-center
                  v-flex.xs10.offset-xs1.text-xs-center CHAMPS SPECIFIQUES
                  v-flex.xs1.text-xs-right
                    v-icon(large dark @click="sheetCustomFieldsOpen = false; modifyingEntityId = null;") close
              v-card-text.sheet-custom-fields(v-rc-loader="ambassadorFieldsLoading")
                rc-custom-fields(v-if="sheetCustomFieldsOpen" :type="type.fieldType" @loading="value => { ambassadorFieldsLoading = value; }" :entityId="modifyingEntityId" ref="ambassadorCustomFields")
        v-list.ambassador-sheets(v-if="ambassadorValues[type.title]")
          v-list-tile.managed-brand(v-for="(sheet, index) in ambassadorValues[type.title]" :class="index === 0 ? 'first-brand' : ''" :key="sheet.id") 
            v-layout.align-center
              div.mr-3
                v-img(v-if="sheet.medias[0]" :src="sheet.medias[0].url" width="64px" height="48px")
                .no-image(v-else)
              .subheading {{ sheet.raison_sociale }}
              v-layout.justify-end
                v-btn(:to="{ name: 'sit_sheets_detail', params: { sheetId: sheet.id }}" color="grey lighten-2" small fab depressed)
                  v-icon.mx-1.grey--text.text--darken-3(medium) search
                v-btn(v-if="atLeastOneField(type.fieldType)" depressed small fab color="grey lighten-2" @click.prevent="modifyingEntityId = sheet.id; sheetCustomFieldsOpen = true")
                  v-icon.mx-1.grey--text.text--darken-3(medium) edit
                v-btn(depressed small fab color="error" @click.prevent="disassociateBrand(sheet.ambassadorId)")
                  v-icon.mx-1(medium dark) delete
</template>

<script>
import RcCustomFields from '@/components/RcClients/RcCustomFields.vue';
import axios from 'axios';

export default {
  components: {
    RcCustomFields,
  },
  data() {
    return {
      addSheetOpen: false,
      availableSheetsLoading: false,
      sheetCustomFieldsOpen: false,
      ambassadorValuesLoading: false,
      ambassadorFieldsLoading: false,
      availableSheets: [],
      ambassadorValues: {},
      sheetCustomFieldsValues: [],
      modifyingEntityId: null,
      loaded: false,
      types: this.$store.state.customFields.types,
      type: {},
      typeName: this.$route.meta.type,
      user: this.$store.state.app.focusedObject,
    };
  },
  mounted() {
    this.type = this.types.find(x => x.name === this.typeName);
    Promise.all([
      this.getAmbassadorValues(),
      this.$store.dispatch('customFields/get', { type: this.type.fieldType }),
    ]).then(() => {
      this.loaded = true;
    });
  },
  computed: {
    atLeastOneField(type) {
      return type => this.$store.state.customFields[type] && this.$store.state.customFields[type].length;
    },
    categories() {
      return this.$store.state.app.sheetCategories;
    },
  },
  methods: {
    async getAmbassadorValues() {
      this.ambassadorValuesLoading = true;
      if (this.user?.ambassadors) {
        this.ambassadorValues = this.user.ambassadors.reduce((obj, it) => {
          if (!obj[it.type.name]) {
            obj[it.type.name] = [];
          }
          return obj;
        }, {});
        await Promise.all(this.user.ambassadors.map(async (it) => {
          if (it.type.name === this.type.title) {
            const sheet = await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).get(`/v2/erp/sheets/${it.value}`);
            if (sheet.data) {
              sheet.data.ambassadorId = it.id;
              this.ambassadorValues[this.type.title].push(sheet.data);
            }
          }
        }));
        if (this.ambassadorValues[this.type.title]) {
          this.ambassadorValues[this.type.title].sort((a, b) => { return a.ambassadorId - b.ambassadorId });
        }
      }
      this.ambassadorValuesLoading = false;
    },
    async disassociateBrand(id) {
      this.ambassadorValuesLoading = true;
      await axios.delete(`/v2/erp/ambassadors/${id}`);
      await this.$store.dispatch('contacts/getContact', { contactId: this.$route.params.contactId });
      await this.getAmbassadorValues();
    },
    async affectSheet(sheetId) {
      this.availableSheetsLoading = true;
      await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).post(`/v2/erp/ambassadors/${this.user.id}/types/${this.type.id}`, { value: sheetId });
      this.modifyingEntityId = sheetId;
      this.ambassadorValuesLoading = true;
      this.$store.dispatch('contacts/getContact', { contactId: this.$route.params.contactId }).then(() => {
        this.getAmbassadorValues();
      });
      this.addSheetOpen = false;
      this.availableSheetsLoading = false;
      if (this.atLeastOneField(this.type.fieldType)) {
        this.sheetCustomFieldsOpen = true;
      }
    },
    async getAvailableSheets() {
      this.availableSheetsLoading = true;
      const availableSheetsResponse = await axios.create({ headers: { 'Cache-Control' : 'no-cache' } }).get(`/v2/erp/clients/${this.user.parent_id}/sheets`);
      this.availableSheets = availableSheetsResponse.data.values.filter(x => !this.user.ambassadors.find(y => (y.value + '') === x.id));
      this.availableSheetsLoading = false;
    },
  },
}
</script>

<style lang="scss">
  .sheet-custom-fields {
    height: calc(90vh - 70px);
    overflow-y: auto;
  }
  .no-image {
    height: 200px;
    background-color: lightgrey;
  }
  .managed-brands {
    height: 500px;
    overflow-y: auto;
  }
  .first-brand {
    border-top: 1px solid lightgrey;
  }
  .ambassador-sheets {
    height: 311px;
    overflow-y: auto;
  }
  .managed-brand {
    border-bottom: 1px solid lightgrey;
    &:hover {
      background-color: #efefef;
    }
  }
</style>
